import React from 'react'
import Settings from '../../Settings'
import {Page} from './../common/StyledComponents'
import {Container, Button} from './Components'

export const Category = ({
  match: {
    params: {locale, categoryKey},
  },
}) => {
  const category = Settings.categories.find(category => category.key === categoryKey)

  return (
    <Page>
      <Container>
        {category.videos.map(video => (
          <Button to={`/${locale}/category/${categoryKey}/video/${video.key}`} key={video.key}>
            <img src={video.img[locale]} alt={video.label} />
          </Button>
        ))}
      </Container>
    </Page>
  )
}
